import { useQuery } from "react-query";
import { getFolders, type Folder } from "../services/api";

export function useFolders() {
  return useQuery<Folder[], Error>("folders", getFolders, {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
  });
}
